import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

const baseStyle = defineStyle({
  // define the part you're going to style
  textDecoration: 'underline',
  color: 'brand.purple',
  fontWeight: 'bold',
});

const linkTheme = defineStyleConfig({
  baseStyle,
});

export default linkTheme;
